//
// submit the form into our custom endpoint
//

var submitForm = (function () {
    'use strict';

    var form = document.querySelectorAll('form');
    var submitButton = document.querySelectorAll(".sf-SubmitButton");

    var subformContainers = ["account_type_container", "ofi_liabilities_container", "income_container", "co_borrower_income_container", "expenditure_container"];
    var subObjectContainers = [];

    // check weather an element is a container of a cloneable section
    function getArraySubformContainer(element) {

        if (element.attr("class")) {
            for (var val of element.attr("class").split(/\s+/)) {
                if (subformContainers.includes(val)) {
                    return val.replace("_container", "_objects");
                }
            }
        }

        return undefined;
    }

    // check weather an element is a container of a section which should be encoded as a subobject
    function getObjectSubformContainer(element) {

        if (element.attr("class")) {
            for (var val of element.attr("class").split(/\s+/)) {
                if (subObjectContainers.includes(val)) {
                    return val.replace("_container", "_data");
                }
            }
        }

        return undefined;
    }

    // serialize all parts of the form including the custom cloned sections into a JSON object
    function serialize(container) {
        var result = {};

        var traverseArray = $(container).children().toArray();
        while (traverseArray.length) {
            var current = $(traverseArray.pop());

            var arraySubformConainerType = getArraySubformContainer(current);
            // check if the element is a container of a clone-able section
            if (arraySubformConainerType) {
                result[arraySubformConainerType] = [];

                // push a JSON serialization of each clone of the section into an array
                for (let clone of $(current).children().toArray()) {
                    result[arraySubformConainerType].push(serialize(clone));
                }

                // continue so that these elements don't get traversed further 
                continue;
            }

            // check if the element is a container of a sub-object section
            var objectSubformContainerType = getObjectSubformContainer(current);
            if (objectSubformContainerType) {
                result[objectSubformContainerType] = {};

                var currentInputsArray = $(current + ' *').toArray();

                // populate the fields of the object with the inputs in the section
                for (let input of currentInputsArray) {
                    input = $(input);
                    if (input.attr("name")) {
                        result[objectSubformContainerType][input.attr("name")] = input.val();
                    }
                }

                // continue so that these elements don't get traversed further 
                continue;
            }

            if (current.attr("name")) {
                if (current.attr("type") == "radio") {
                    // if it's a yes/no button group it should be handled specially - find the only checked button and get it's val
                    var val = current.closest("div.btn-group-toggle").find('label.active input[type="radio"]').val();
                    result[current.attr("name")] = val;
                } else {
                    var value = current.val();
                    if (value == "Please select") {
                        value = "";
                    }
                    result[current.attr("name")] = value;
                }
            }

            for (var child of current.children().toArray()) {
                // add children elements to be traversed
                traverseArray.push(child);
            }
        }

        return result;
    }

    // ################################# 
    // This is the section where we map the serialized form payload to the expected format from the API.
    // #################################

    const payloadArrayKeyMapping = {
        "account": "account_type_objects",
        "other_liabilities": "ofi_liabilities_objects"
    };

    function deepCopyObject(object) {
        return JSON.parse(JSON.stringify(object));
    }

    const expenditureTypeMapping = {
        "exp_rent": "Rent",
        "exp_utilities": "Utilities",
        "exp_groceries": "Groceries",
        "exp_transport": "Public Transport & Vehicle running cost",
        "exp_comms": "TV and Communications",
        "exp_health": "Health",
        "exp_insurance": "Personal Insurance",
        "exp_lifestyle": "Lifestyle",
        "exp_household": "Household",
        "exp_personal": "Personal",
        "exp_prop_investment": "Property Investment",
        "exp_prof_services": "Professional Cost and Service",
        "exp_education": "Private Education",
        "exp_public_education": "Childcare and Public Education",
        "exp_child_spouse": "Child Spousal maintenance",
        "exp_other": "Other expense"
    };

    function populateIncomeExpenses(type, object, payload, prefixes) {
        object.item.length = 0;

        var payloadKey = `${prefixes}${type}_objects`;
        var payloadObject = payload[payloadKey];

        for (var item of payloadObject) {
            var element = {};
            if (type == "income") {
                element.type = item[`${prefixes}income_type`];
                element.amount = item[`${prefixes}income_amount`];
                element.frequency = item[`${prefixes}income_frequency`];
                object.item.push(element);
            } else if (type == "expenditure") {
                for (var key in item) {
                    if (!key.endsWith("_frequency")) {
                        element.amount = item[key];
                        element.frequency = item[`${key}_frequency`];
                        element.type = expenditureTypeMapping[key];
                        object.item.push(element);
                    }
                }
            }
        }

        object.comments = payload[`${prefixes}${type}_comments`];
    }

    function populateAccounts(value, payload) {
        value.length = 0;

        $("input[name='accounts']").each(function (index, el) {
            if ($(this).is(":checked")) {
                var val = $(this).val();
                if (val == "Home Loan(s)") {
                    $("input[name='mortgageTypes']").each(function (index, el) {
                        if ($(this).is(":checked")) {
                            value.push({ "type": $(this).val() });
                        }
                    });
                } else {
                    value.push({ "type": val });
                }
            }
        });
    }

    function getMaintainPaymentsStatus() {
        var fullMaintainSelector = "label.active input[name='can_maintain_curr_min_monthly_repayment']";
        var partialMaintainSelector = "label.active input[name='can_maintain_partial_repayment']";

        var fullMaintain = $(fullMaintainSelector).val() == "Yes";
        if (fullMaintain) {
            return "Yes";
        }

        var partialMaintain = $(partialMaintainSelector);
        return partialMaintain.val() == "Yes" ? "Partial" : "No";
    }

    function getCountryCode(key, value) {
        var input = $(`[name='${value}']`);
        var flagContainer = input.parent();
        var countryCode = flagContainer.find("div.iti__selected-flag").attr("title");
        return countryCode;
    }

    function getRelationship() {
        return $("input[name='joint_products_status']:checked").val() == "Yes" ? "Joint" : "Sole";
    }

    function populateObject(object, payload, prefixes = "") {
        for (var key in object) {
            var value = object[key];
            var payloadKey;
            if (typeof value === "string") {
                if (key == "maintain_payments") {
                    object[key] = getMaintainPaymentsStatus();
                    continue;
                }
                if (key == "relationship") {
                    var relationshipInPayload = payload[value]; // might cause a bug for a future change since it's missing the prefixes
                    object[key] = relationshipInPayload == "Yes" ? "Joint" : "Sole";
                    continue;
                }
                if (key == "number") {
                    if (object.hasOwnProperty("country_code")) {
                        object["country_code"] = getCountryCode(key, value);
                    }
                }
                if (key == "country_code") {
                    continue;
                }

                payloadKey = `${prefixes}${value}`;

                if (payload[payloadKey] != undefined) {
                    object[key] = payload[payloadKey];
                }
            } else if (typeof value === "object" && !Array.isArray(value)) {
                if (key == "income" || key == "expenditure") {
                    populateIncomeExpenses(key, value, payload, prefixes);
                    continue;
                }

                populateObject(value, payload, prefixes);
            } else if (Array.isArray(value)) {
                if (key == "applicant") {
                    populateApplicant(value, payload);
                    continue;
                }

                if (key == "account") {
                    populateAccounts(value, payload);
                    continue;
                }

                payloadKey = payloadArrayKeyMapping[key];

                var payloadArray = payload[payloadKey];

                var objectBlankCopy = deepCopyObject(value[0]);
                value.length = 0; 

                if (payloadArray) {
                    for (var element of payloadArray) {
                        var copy = deepCopyObject(objectBlankCopy);
                        populateObject(copy, element);

                        value.push(copy);
                    }
                }
            }
        }
    }

    function populateCoBorrower(object, payload) {
        populateObject(object, payload, "co_borrower_");
    }

    function checkOverrideCoBorrowerAddress(primaryBorrower, coBorrower) {
        if ($("[name='co_borrower_same_address']").prop("checked")) {
            coBorrower.contact.address = primaryBorrower.contact.address;
        }
    }

    function populatePrimaryBorrower(object, payload) {
        populateObject(object, payload);
    }

    function populateApplicant(applicantArray, payload) {

        var primaryBorrower = applicantArray[0];
        var coBorrower = applicantArray[1];
        populatePrimaryBorrower(primaryBorrower, payload);

        if (getCurrentPath() === "Business") {
            var officer = applicantArray[1];
            populateObject(officer, payload);

            var hasSecondOfficer = $("input[name='coborrower_status_0']:checked").val() === "Yes";
            if (hasSecondOfficer) {
                var officer2 = applicantArray[2];
                populateObject(officer2, payload);
                if ($("input[name='co_borrower_same_address_0']").prop("checked")) {
                    officer2.contact.address = officer.contact.address;
                }
            }
            else {
                applicantArray = applicantArray.splice(2);
            }
        }
        else {
            var coBorrowerPresent = $("input[name='coborrower_status']:checked").val() == "Yes";

            if (!coBorrowerPresent) {
                applicantArray = applicantArray.splice(1);
            } else {
                populateCoBorrower(coBorrower, payload);
                checkOverrideCoBorrowerAddress(primaryBorrower, coBorrower);
            }
        }
    }

    function populateJson(exampleJson, payload) {
        populateObject(exampleJson, payload);

        return exampleJson;
    }


    // get the selector of the frequency dropdown for the field
    function getDropdownSelector(inputName) {
        return `select[name='${inputName}_frequency']`;
    }
    
    // validate the data on the page which has the submit button. we do that because we prevent the default behaviour on the submit button
    function validateLastPage() {
        var inputs = $("form").find("input");

        var result = true;

        for (var inputId in inputs.toArray()) {
            var inputName = $(inputs[inputId]).attr("name");
            var select = $(getDropdownSelector(inputName));
            var errorMessageId;

            // validate the frequency fields
            if (select.length && !select.attr("disabled") && select.is(":invalid")) {
                // show the error message
                errorMessageId = select.attr("aria-describedby");
                $(`#${errorMessageId}`).show();
                $(`#${errorMessageId}`).text("Frequency field input is required");
                result = false;
            }

            var input = $(inputs[inputId]);
            if ($(input).is(":invalid") && $(input).is(".currency") && $(input).is(":visible")) {
                errorMessageId = $(input).attr("aria-describedby");
                $(`#${errorMessageId}`).show();
                $(`#${errorMessageId}`).text("Input field is required. Makе sure it has maximum of 14 numbers");
                result = false;
            }
        }
        return result;
    }


    var pathInputsSelector = "[name^='path_']";

    function getCurrentPath() {

        var pathInputs = $(`${pathInputsSelector}:checked`);
        var yesCount = 0;

        for (var pathInput of pathInputs.toArray()) {
            if ($(pathInput).val() == "Yes") {
                yesCount++;
            }
        }
        return yesCount == 3 ? "Business" : "Consumer";
    }

    function displayErrorMsg() {
        // there's a button with display:none inline style which triggers a modal..
        var path = getCurrentPath();
        $(`#toggleErrorMsg${path}`).click();
        $(submitButton).removeAttr('disabled');
        $("body").addClass("hasError");
        resetCaptcha();
    }

    function clearFormData() {
        if ($("form").length){
            $("form")[0].reset();
            $("label.btn-outline-main").removeClass("active");
            resetCaptcha();
        }
    }

    window.onload = clearFormData;

    function resetCaptcha() {
        $(`a[data-sf-role="captcha-refresh-button"]`).click();
    }

    function fineTunePayload(payload, path) {
        if (payload.maintain_payments == "Yes") {
            payload.assistance_period = "";
        }


        if (path == "Consumer") {
            var noIndustryStatuses = ["Unemployed", "Studying", "Pensioner"];
            for (var applicant of payload.applicant) {
                if (noIndustryStatuses.includes(applicant.employment.status)) {
                    applicant.employment.industry = "N/A";
                }
            }
        }

        return payload;
    }

    function fixOfiJointStatus(payload) {
        var actualStatusKey = "joint_products_status";

        for (var ofi of payload.ofi_liabilities_objects) {
            for (var key in ofi) {
                if (key.startsWith(actualStatusKey)) {
                    var status = ofi[key];
                    delete ofi[key];
                    ofi[actualStatusKey] = status;
                }
            }
        }

        return payload;
    }

    function init() {
        $(submitButton).on("click", function (e) {
            var button = $(this);

            e.preventDefault ? e.preventDefault() : e.returnValue = false;
            $(submitButton).attr('disabled', true);

            // find the captcha input in the current page
            var captchaInput = $(this).closest("div[data-sf-role='separator']").find('input[data-sf-role="captcha-input"]');
            // the input field has a validator function in it's data which makes a request to the server to validate the captcha and returns a promise
            if (captchaInput && captchaInput.length > 0) {
                captchaInput.data('widget-validator')().done(isValidCaptcha => {
                    if (!validateLastPage() || !isValidCaptcha) {
                        $(submitButton).removeAttr('disabled');
                        return;
                    }

                    submitForm();
                });
            }
            else {
                submitForm();
            }
        });
    }

    if (submitButton.length) {
        init();
    }

    function setAnalyticsApplicationId(appId) {
        if (window.digitalData &&
            window.digitalData.page &&
            window.digitalData.page.application &&
            window.digitalData.page.application.referenceId) {
            window.digitalData.page.application.referenceId = appId;
        }
    }

    function submitForm() {
        var path = getCurrentPath();
        var payload = serialize(form);

        $("body").removeClass("hasError");

        payload = fixOfiJointStatus(payload);

        $.ajax({
            method: "get",
            url: `/webapi/get-config?path=${path}`,
            beforeSend: function () {
                $('#loader').fadeIn('slow');
            },
            complete: function () {
                $('#loader').delay(350).fadeOut('slow');
            },
            success: function (exampleJson) {
                exampleJson = JSON.parse(exampleJson);

                let result = populateJson(exampleJson, payload);
                result = fineTunePayload(result, path);
                var insightsSession = "";

                if (window.appInsights &&
                    window.appInsights.context &&
                    window.appInsights.context.user &&
                    window.appInsights.context.user.id) {
                    insightsSession = appInsights.context.user.id;
                }

                $.ajax({
                    method: "post",
                    url: "/webapi/submit-hardship?sessionId=" + insightsSession,
                    data: JSON.stringify({
                        Payload: result,
                        OriginalData: payload
                    }),
                    beforeSend: function(request) {
                        request.setRequestHeader("X-Request-Id", $("[data-sf-role=__requestId]").val());
                    },
                    contentType: "application/json",
                    success: function (res) {
                        if (res.status === "SUCCESS") {

                            setAnalyticsApplicationId(res.application_id);
                            sessionStorage.setItem("application_id", res.application_id);
                            clearFormData();
                            window.location = `/thank-you?path=${path.toLowerCase()}`;
                        } else {
                            displayErrorMsg();
                        }
                    },
                    error: function (request, status, error) {
                        displayErrorMsg();
                    }
                });
            },
            error: function (request, status, error) {
                displayErrorMsg();
            }
        });
    }
})();